<template>
  <li class="nav-item">
    <slot>
      <CLink
        :class="linkClasses"
        :aria-current="currentPage === `${name}` ? 'page' : ''"
        v-bind="computedLinkProps"
      >
        <i v-if="icon" v-bind="computedIcon" data-trigger="hover" data-toggle="tooltip" data-placement="right"/>
        <span class="menu-title">{{name}}</span>
        <!-- <CBadge
          v-if="badge"
          v-bind="Object.assign({}, badge, { text: null })"
        >
          {{badge.text}}
        </CBadge> -->
      </CLink>
    </slot>
  </li>
</template>

<script>
import CLink, { props as linkProps } from './CLink'
// import CBadge from '../badge/CBadge'

const props = Object.assign(
  {}, 
  linkProps, 
  {
    exact: {
      type: Boolean,
      default: true
    },
    activeClass: {
      type: String,
      default: 'c-active'
    }
  },
  {
    name: String,
    icon: [String, Object],
    fontIcon: String,
    badge: Object,
    addLinkClasses: [String, Array, Object],
    label: Boolean,
    permission_slug : String
  }
)

export default {
  name: 'CSidebarNavItem',
  components: {
    CLink, 
    // CBadge,
  },
  props,
  computed: {
    // permissions(){
    //   // console.log(this.$store.getters.userObj.admin.permissions);
    //   let permissions = this.$store.getters.userObj.admin.permissions;
    //   console.log(permissions, this.permission_slug, permissions.includes(this.permission_slug));
    //   return permissions.includes(this.permission_slug)
    // },
    currentPage() {
        return this.$route.name 
    },
    computedLinkProps () {
      return Object.keys(linkProps).reduce((props, key) => {
        props[key] = this[key]
        return props
      }, {})
    },
    linkClasses () {
      return [
        this.label ? 'c-sidebar-nav-label' : '',
        this.addLinkClasses
      ]
    },
    computedIcon () {
      if (typeof this.icon === 'object') {
        const key = this.icon.size ? 'class' : 'customClasses'
        return Object.assign(
          { [`${key}`]: 'c-sidebar-nav-icon' },
          this.icon
        )
      } else {
        return { class: this.icon }
      }
    }
  },
  mounted() {
    this.permissions;
  }
}
</script>

<style scoped>
.menu-title {
    font-size: 16px;
    font-family: 'Avenir Next W1G Medium';
    vertical-align: middle;
}

[aria-current="page"] {
    color: #32417E !important;
    border-left: 4px solid #32417E;
}
</style>